import React, { Component } from 'react';
import PropTypes from 'prop-types';
import BalanceModificationTransactionsDeleteDialog from './BalanceModificationTransactionsDeleteDialog';
import InternalRepatriationCreateFormDialog from '../../../../../reporting/internal-repatriation/containers/InternalRepatriationCreateFormDialog';
import BalanceModificationTransactionsEditDialog from '../../edit/containers/BalanceModificationTransactionsEditDialog';

class BalanceModificationTransactionsDelete extends Component {
  render() {
    return (
      <div>
        <BalanceModificationTransactionsDeleteDialog
          row={this.props}
          closeDialog={this.props.closeDialog}
          openDialog={this.props.openDialog}
          refreshTransactions={this.props.refreshTransactions}
          refreshHistories={this.props.refreshHistories}
        />
      </div>
    );
  }
}

BalanceModificationTransactionsDelete.propTypes = {
  closeDialog: PropTypes.func.isRequired,
  openDialog: PropTypes.func.isRequired,
  refreshTransactions: PropTypes.func,
  refreshHistories: PropTypes.func,
};

export default BalanceModificationTransactionsDelete;
